import {getHashState} from 'app/components/tabNavigation/utils/getHashState';
import {getSelectedIndexFromId} from 'app/components/tabNavigation/utils/getSelectedIndexFromId';
import {addScrollDeeplinkItemAction} from 'app/modules/scrollDeeplink/actions';
import {TabNavigationConfig} from 'interfaces/common/components/general/tab/tabNavigationConfig';

export function addLazyScroll(cId: string, tabItems: NonNullable<TabNavigationConfig['tabItems']>) {
    const hash = window.location.hash.substring(1);
    const tabsUrlState = getHashState(hash, cId);
    if (tabsUrlState?.id) {
        addScrollDeeplinkItemAction({cId, type: 'LAZY_SCROLL', component: 'TAB_NAVIGATION', tabIndex: getSelectedIndexFromId(tabItems, tabsUrlState.id)});

        return true;
    }

    return false;
}
